<ng-container *transloco="let t">
  <div class="koproloski-finding" [formGroup]="form">
    <div class="field">
      <label class="label">{{ t('kopro.makroscopic') }}</label>
      <mat-form-field appearance="outline" class="w-full">
        <textarea
          matInput
          formControlName="makroscopicFinding"
          rows="4"
        ></textarea>
      </mat-form-field>
    </div>

    <div class="field">
      <label class="label">{{ t('kopro.mikroscopic') }}</label>
      <mat-form-field appearance="outline" class="w-full">
        <textarea
          matInput
          formControlName="mikroscopicFinding"
          rows="4"
        ></textarea>
      </mat-form-field>
    </div>

    <div class="field">
      <label class="label">{{ t('kopro.note') }}</label>
      <mat-form-field appearance="outline" class="w-full">
        <textarea matInput formControlName="note" rows="4"></textarea>
      </mat-form-field>
    </div>

    <mat-form-field appearance="outline" class="w-full mb-3">
      <mat-label>{{ t('veterinarianName') }}</mat-label>
      <input matInput formControlName="veterinarianName" />
      <mat-error>{{ t('This field is required') }}</mat-error>
    </mat-form-field>
  </div>
</ng-container>
